import { Component } from '@angular/core';
import { SessionService } from '../Util/Session/session.service';
import { CommonService } from '../Model/Common/common.service';
import { ToastService, toastTypeEnum } from '../Util/Toast/toast.service';
import { CustomDateParserFormatter } from '../Util/DateFormat/date-format.service';
import { ActivatedRoute, Router, RouterModule, RouterOutlet } from '@angular/router';
import { TooltipService } from '../Util/Tooltip/tooltip.service';
import { NgbAlertModule, NgbDateParserFormatter, NgbDatepickerModule, NgbDropdownModule, NgbModal, NgbNavModule, NgbTimepickerModule, NgbTooltip } from '@ng-bootstrap/ng-bootstrap';
import { CompensatoryOffService } from '../Model/CompensatoryOff/compensatory-off.service';
import { LoaderComponent } from '../Component/Loader/loader/loader.component';
import { AsyncPipe, CommonModule, DecimalPipe, JsonPipe } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AlertSuccessComponent } from '../Component/Alert/alert-success/alert-success.component';
import { AlertWarningComponent } from '../Component/Alert/alert-warning/alert-warning.component';
import { CompensatoryOffFormPopupComponent } from '../Request/CompensatoryOff/compensatory-off-form-popup/compensatory-off-form-popup.component';
import { ConfirmationComponent } from '../Component/Confirmation/confirmation/confirmation.component';
import { DataTablesModule } from 'angular-datatables';

@Component({
  selector: 'app-admin-comp-off-form',
  standalone: true,
  imports: [NgbNavModule, NgbDatepickerModule, FormsModule, NgbAlertModule, NgbTimepickerModule, CommonModule, DataTablesModule, ReactiveFormsModule, NgbDropdownModule, RouterModule, LoaderComponent],
  providers: [{ provide: NgbDateParserFormatter, useClass: CustomDateParserFormatter },],
  templateUrl: './admin-comp-off-form.component.html',
  styleUrl: './admin-comp-off-form.component.scss'
})
export class AdminCompOffFormComponent {

  constructor(
    private session: SessionService,
    public common: CommonService,
    public toast: ToastService,
    public dateFormate: CustomDateParserFormatter,
    private router: Router,
    protected tooltip: TooltipService,
    private modalService: NgbModal,
    private compensatoryOff: CompensatoryOffService,
    private route: ActivatedRoute
  ) {
    // this.common.getPageRights();
    this.user = session.GetUserDetails();
    this.Compensatory.AdminRequestBy = this.user.UserId;
    this.route.params.subscribe((params: { [x: string]: string; }) => this.Compensatory.EmpMasterID = parseInt(params['id']));
    console.log(this.Compensatory.EmpMasterID);
  }

  isDisabled: boolean = false;
  HalfDaySessions = [{ Name: 'First Half', Value: 'First Half' }, { Name: 'Second Half', Value: 'Second Half' }]
  user = {} as any;

  Compensatory = {
    SelectType: 'I',
    ESS_EmployeeCompOffRaiseId: 0,
    DailyAttendanceInOutID: 0,
    EmpMasterID: null as any,
    AttendanceDate: null as any,
    AttendanceDateObj: null,
    InTime: null as any,
    InTimeObj: null as any,
    OutTime: null as any,
    OutTimeObj: null as any,
    HalfDay: false,
    HalfDaySession: null,
    Reason: null,
    IsAdminRequest: true,
    AdminRequestBy: 0,
    IsAdminWithdrawn: false,
    AdminWithdrawnRequestBy: 0,
  };

  Validate(form: any) {
    if (form.valid) {
      if (this.Compensatory.OutTimeObj.hour > this.Compensatory.InTimeObj.hour || (this.Compensatory.OutTimeObj.hour == this.Compensatory.InTimeObj.hour && this.Compensatory.OutTimeObj.minute >= this.Compensatory.InTimeObj.minute)) {
        this.ESS_EmployeeCompOffRaiseUpdate();
      } else {
        this.toast.show({ message: 'Out time must be greater than in time.', type: toastTypeEnum.warning });
      }
    }
    else {
      form.submitted = true;
    }
  }

  async ESS_EmployeeCompOffRaiseUpdate() {
    //await this.common.getPageRights();
    const modalRef = this.modalService.open(ConfirmationComponent);
    modalRef.componentInstance.Message = 'Do you want to save?';
    modalRef.result.then(result => {
      //if ((this.common.PageRight.IsAdd && this.Compensatory.ESS_EmployeeCompOffRaiseId == 0) || (this.common.PageRight.IsEdit && this.Compensatory.ESS_EmployeeCompOffRaiseId > 0)) {
      if (result) {
        this.isDisabled = true;
        this.Compensatory.AttendanceDate = this.dateFormate.format(this.Compensatory.AttendanceDateObj);
        // this.Compensatory.InTime = this.Compensatory.InTimeObj.hour + ':' + this.Compensatory.InTimeObj.minute;
        // this.Compensatory.OutTime = this.Compensatory.OutTimeObj.hour + ':' + this.Compensatory.OutTimeObj.minute;

        this.compensatoryOff.ESS_EmployeeCompOffRaiseUpdate(this.Compensatory).subscribe({
          next: (response) => {
            if (response.Error_Code == "392") {
              const modalRef = this.modalService.open(AlertSuccessComponent, {
                size: 'md',
                backdrop: 'static',
                centered: true,
                windowClass: 'confirmation-modal'
              });
              modalRef.componentInstance.Message = response.Error_Message;
              modalRef.result.then((result: any) => {
                if (result) {
                  this.close();
                }
              });
            } else {
              const modalRef = this.modalService.open(AlertWarningComponent, {
                size: 'md',
                backdrop: 'static',
                centered: true,
                windowClass: 'confirmation-modal'
              });
              modalRef.componentInstance.Message = response.Error_Message;
              modalRef.result.then((result: any) => { });
            }
            this.isDisabled = false;
          },
          complete: () => { },
          error: (error) => {
            this.isDisabled = false;
          },
        });
      }
    });
  }

  close() {
    this.router.navigate(['/request/admincompoff/']);
  }

  Clear() {
    this.Compensatory.DailyAttendanceInOutID = 0;
    this.Compensatory.InTimeObj = null
    this.Compensatory.OutTimeObj = null
  }

  Openpopup() {
    if (this.Compensatory.AttendanceDateObj != null && this.Compensatory.AttendanceDateObj != '') {
      const modalRef = this.modalService.open(CompensatoryOffFormPopupComponent, { size: 'xl', backdrop: 'static' });
      modalRef.componentInstance.AttendanceDate = this.dateFormate.format(this.Compensatory.AttendanceDateObj);
      modalRef.componentInstance.EmpMasterID = this.Compensatory.EmpMasterID;
      console.log(modalRef.componentInstance.EmpMasterID);
      modalRef.result.then(result => {
        if (result != null && result != undefined) {
          this.Compensatory.DailyAttendanceInOutID = result.DailyAttendanceInOutId;
          if (result.InTime != null && result.InTime != '') {
            this.Compensatory.InTime = result.InTime;
            this.Compensatory.InTimeObj = { hour: parseInt(result.InTime.split("T")[1].split(":")[0]), minute: parseInt(result.InTime.split("T")[1].split(":")[1]) }
          }
          if (result.OutTime != null && result.OutTime != '') {
            this.Compensatory.OutTime = result.OutTime;
            this.Compensatory.OutTimeObj = { hour: parseInt(result.OutTime.split("T")[1].split(":")[0]), minute: parseInt(result.OutTime.split("T")[1].split(":")[1]) }
          }
        }
      });
    } else {
      this.toast.show({ message: "Please Select Date", type: toastTypeEnum.warning });
    }
  }

  timeFormate(event: any, type: String) {
    if (type == 'InTime') {
      if (event.target.placeholder == 'HH') {
        event.target.value = this.Compensatory.InTimeObj.hour.toLocaleString('en-US', { minimumIntegerDigits: 2, useGrouping: false })
      } else if (event.target.placeholder == 'MM') {
        event.target.value = this.Compensatory.InTimeObj.minute.toLocaleString('en-US', { minimumIntegerDigits: 2, useGrouping: false })
      }
    } else if (type == 'OutTime') {
      if (event.target.placeholder == 'HH') {
        event.target.value = this.Compensatory.OutTimeObj.hour.toLocaleString('en-US', { minimumIntegerDigits: 2, useGrouping: false })
      } else if (event.target.placeholder == 'MM') {
        event.target.value = this.Compensatory.OutTimeObj.minute.toLocaleString('en-US', { minimumIntegerDigits: 2, useGrouping: false })
      }
    }
  }

}
